<template>
  <div id="app">
    <!--img src="./assets/logo.png"></img -->
    
    <router-view/>
 
	
  </div>
</template>

<script>
 
export default {
  name: 'App',
 
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  margin-top: -60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue